module.exports = __webpack_public_path__ + "img/img_vision_02.e04f8831.png";